module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-2021-2.5bc1eb66.jpg";